import styled from '@emotion/styled';

import { theme } from '@/theme';

export const StyledDrawerWrapper = styled('nav')<{ width: string; withsidebar: string }>`
    transition: ${theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    })};

    width: 0;

    ${theme.breakpoints.up('sm')} {
        width: ${({ width, withsidebar }) => (withsidebar === 'true' ? width : '0')};
        flex-shrink: 0;
    }
`;

export const StyledDrawerContent = styled('div')<{ width: string }>`
    width: ${({ width }) => width};
    display: grid;
    height: 100%;
    grid-template-columns: 1fr;
    grid-template-rows: 10rem 1rem 2fr 0.1fr;
    grid-template-areas:
        'logoArea'
        'divider1'
        'content'
        'footer';
`;

export const StyledHeaderArea = styled('div')`
    padding: 2.5rem 0 1.4rem 0.8rem;
    display: grid;
    grid-template-columns: 06fr 24fr;
    grid-template-rows: 1fr;
    grid-template-areas:
        'closeIcon'
        'logoImage';
    grid-area: logoArea;
`;

export const StyledCloseArea = styled('div')`
    grid-area: closeIcon;
    display: flex;

    svg {
        transition: all ease-out 0.077s;
    }

    button:hover {
        svg {
            color: ${theme.palette.common.white};
        }
    }
`;

export const StyledLogoArea = styled('div')`
    display: flex;
    justify-content: 'center';
`;

export const StyledContentArea = styled('div')`
    grid-area: content;
`;
